import axiosClient from "../../../../api/axiosClient";


// =============================================================================
// GET TRACEABILITY REPORT
// =============================================================================

export async function getMaterialTraceabilityReport(
  params = {}
) {

  const response =
    await axiosClient.get(


"/api/pms/material-receipt/material-traceability/report",

      {
        params
      }
    );

  return response.data;
}